"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.apiCustomer_post = exports.api_customer_post_failure = exports.api_customer_post_success = exports.api_customer_post_request = exports.API_CUSTOMER_POST_FAILURE = exports.API_CUSTOMER_POST_SUCCESS = exports.API_CUSTOMER_POST_REQUEST = undefined;

var _index = require("axios/index");

var _index2 = _interopRequireDefault(_index);

var _nodeToolbox = require("@esnpm/node-toolbox");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_CUSTOMER_POST_REQUEST = exports.API_CUSTOMER_POST_REQUEST = "API_CUSTOMER_POST_REQUEST";
var API_CUSTOMER_POST_SUCCESS = exports.API_CUSTOMER_POST_SUCCESS = "API_CUSTOMER_POST_SUCCESS";
var API_CUSTOMER_POST_FAILURE = exports.API_CUSTOMER_POST_FAILURE = "API_CUSTOMER_POST_FAILURE";

var api_customer_post_request = exports.api_customer_post_request = function api_customer_post_request(options) {
	return {
		type: API_CUSTOMER_POST_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

var api_customer_post_success = exports.api_customer_post_success = function api_customer_post_success(data) {
	return {
		type: API_CUSTOMER_POST_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

var api_customer_post_failure = exports.api_customer_post_failure = function api_customer_post_failure(error) {
	return {
		type: API_CUSTOMER_POST_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Customer.apiCustomer_post
*/
var apiCustomer_post = exports.apiCustomer_post = function apiCustomer_post(options) {
	return (
		// eslint-disable-next-line no-unused-vars
		function (dispatch, getState) {
			return new _bluebird2.default(
			// eslint-disable-next-line no-unused-vars
			function (resolve, reject) {
				dispatch(api_customer_post_request(options));
				var url = (0, _nodeToolbox.getAPIUrl)([{ "parameters": [], "url": "/api/customer" }, { "parameters": ["CUSTOMER_ID"], "url": "/api/customer/${options.CUSTOMER_ID}" }], options);
				(0, _index2.default)({
					method: "post",
					url: url,
					data: {
						ADDRESSES: options.ADDRESSES,
						CASH_DISCOUNT: options.CASH_DISCOUNT,
						COMMENT: options.COMMENT,
						COMPANY: options.COMPANY,
						CONTACTS: options.CONTACTS,
						CREATED: options.CREATED,
						CREDIT_LIMIT: options.CREDIT_LIMIT,
						CUSTOMER_FLAGS: options.CUSTOMER_FLAGS,
						CUSTOMER_ID: options.CUSTOMER_ID,
						CUSTOMER_SUPPLIER_NUMBER: options.CUSTOMER_SUPPLIER_NUMBER,
						CUSTOMER_TYPE: options.CUSTOMER_TYPE,
						DISABLED: options.DISABLED,
						DISCOUNT: options.DISCOUNT,
						LOCATIONS: options.LOCATIONS,
						PAYMENT_INVOICE: options.PAYMENT_INVOICE,
						SHARED_ACCOUNT: options.SHARED_ACCOUNT,
						TIME_FOR_CASH_DISCOUNT: options.TIME_FOR_CASH_DISCOUNT,
						TIME_FOR_PAYMENT: options.TIME_FOR_PAYMENT,
						UPDATED: options.UPDATED,
						VATIDS: options.VATIDS,
						WEBSITE: options.WEBSITE
					}
				}).then(function (response) {
					if (response.data.SUCCESSFUL) {
						dispatch(api_customer_post_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_customer_post_failure(response.data));
						resolve();
					}
				}, function (err) {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				});
			});
		}
	);
};